// extracted by mini-css-extract-plugin
module.exports = {"root":"socials_root__rIvCv","icon":"socials_icon__sANM8","large":"socials_large__oapwi"};